import { style } from '@vanilla-extract/css';

export const genericEmbedContainer = style({
  display: 'flex',
  gap: '2rem',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
});
